module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form', {
		configure: function (options) {
			this.registerOptions('', {
				resetOnBuilt: true,
				container: '@parent',
				loadValuesOnRun: true
			});
			this.callParent('configure', arguments);
		},

		init: function() {
			this._values = {}; //need to reset this._values somewhere
			this._beforeBuildValues = {};
			this._defaults = {};
			this._log = [];
			this._redoLog = [];
			this._skipLog = false;
			this._skipCleanRedo = false;
			this._ignoreSubmit = false;
			this._isBuilt = false;
			this._hasSelectors = false;

			this.sendTimer = 250;
			this.sendTimerId = null;
			this.silent = false;

			fox.each(this.options.formElements, function(desc, alias) {
				// defaultValuesLoaded
				if (fox.isSet(desc.defaultValue)) {
					this._defaults[alias] = desc.defaultValue;
				}

				if (fox.isObject(desc.element)) {
					desc.element.autoApply = desc.element.autoApply || this.getOption('autoApply');
					this.embedWidget(alias, desc.element.widget, desc.element);
				} else if (fox.isString(desc.element)) {
					this._hasSelectors = true;
				}
			}, this);
		},

		loadDefaultValues: function() {
			var api = this._getFormDataApi(),
				params = this.getOption('methods.getParams') || {};
			
			this.handleEvent(api, ['success'], fox.bind(function(transport) {
				if (!transport.transport.status) {
					return;
				}
				if (!fox.isEmpty(transport.answer.response)) {
					this._defaults = transport.answer.response;
				}

				if (this._isBuilt) {
					this._updateElements();
					this.resetForm();
				}
				this.dispatchEvent('defaultValuesLoaded');
			}, this));

			api.send(params, false);
		},

		_getFormDataApi: function () {
			var
				api = this.wom1('#formDataApi');

			if (!api) {
				api = this.embedWidget('formDataApi', 'Api', {
					method: this.getOption('methods.get'),
					sendTimezone: true
				});

				api.run();
			}

			return api;
		},

		_getFormSendApi: function () {
			var
				api = this.wom1('#formDataSaveApi');

			if (!api) {
				api = this.embedWidget('formDataSaveApi', 'Api', {
					method: this.getOption('methods.send'),
					sendTimezone: true
				});

				api.run();
			}

			return api;
		},

		loadValues: function() {
			if (this.getOption('methods.get')) {
				this.loadDefaultValues();
			} else {
				this.dispatchEvent('defaultValuesLoaded');
			}
		},

		_embedWidget: function(alias, widget, options) {
			var w  = this.callParent('_embedWidget', arguments);

			if (this.options.formElements[alias] && !fox.isSet(this._defaults[alias])) {
				this._defaults[alias] = w.emptyValue;
			}
			
			return w;
		},

		running: function() {
			if (this.options.loadValuesOnRun) {
				this.loadValues();
			}
			
			if (this._hasSelectors) {
				this.handleEvent(this.requireOption('container'), 'addedToDom', fox.bind(this._runSelectors, this),
					{prefix: 'embed_' + this.getHash(), listenHistory: true}
				);
				//this._performStateDependency({subject: '@this', event: 'elementsUpdated'}, this._createWidgets);
			} else {
				this._performStateDependency({subject: '@this', event: 'defaultValuesLoaded'}, this.built);
			}

			if (!this.getOption('methods.send')) {
				this.silent = true;
				return;
			}
			
			this.api = this._getFormSendApi();
			if (this.getOption('methods.sendMethod')) {
				this.api.setOption('httpMethod', this.getOption('methods.sendMethod'));
			}
			
			if (this.getOption('methods.encodePost')) {
				this.api.setOption('encodePost', this.getOption('methods.encodePost'));
			}
	
			var cb = this.getOption('responseCallback') || fox.bind(function(answer, type) {
				this.hookWrapper('response', {response: answer.answer.response, type: type, answer: answer});
			}, this);

			this.handleEvent(this.api, ['success'], function(answer) {
				cb(answer, 'send');
			});
			
			this.handleEvent(this.api, ['error', 'failure'], function(answer) {
				cb(answer, 'error', 'send');
			});
		},

		getContainer: function() {
			return this.options.formContainer ? fox.dom.selectFirst(this.options.formContainer, this.getParent().element) : this.rwom1(this.getOption('container')).element;
		},

		_runSelectors: function() {
			if (this.getOption('submit')) {
				var performer = this.rwom1(this.getOption('container'));

				if (this.getOption('submit.targetWidget')) {
					performer = this.rwom1(this.getOption('submit.targetWidget'));
				}

				performer.addDomHandler({
					target: this.getOption('submit.target'),
					event: this.getOption('submit.event') || 'submit',
					callback: fox.bind(this._submitHandler, this)
				}, 'submit');
			}

			this._updateElements();
		},

		_updateElements: function() {
			this.formSelectedElements = {};
			fox.each(this.options.formElements, function(desc, alias) {
				if (fox.isString(desc.element)) {
					this.formSelectedElements[alias] = fox.dom.select(desc.element, this.getContainer());
				}
			}, this);

			this._createWidgets();

			this.dispatchEvent('elementsUpdated');
		},

		getFormElement: function(alias) {
			return this.formSelectedElements[alias] || false;
		},

		_createWidgets: function() {
			this.createWidgetsFromSelectors();
			this._performStateDependency({subject: '@this', event: 'defaultValuesLoaded'}, this.built);
		},

		built: function() {
			this._isBuilt = true;

			if (this.getOption('resetOnBuilt')) {
				this.resetForm();
			}
		},

		createWidgetsFromSelectors: function() {
			fox.each(this.options.formElements, function(desc, alias) {
				var elem = this.getFormElement(alias)
				if (desc.element && fox.isString(desc.element) && elem) {
					if (!this.getEmbeddedWidget(alias)) {
						this._embedWidgetByElement(alias, elem, desc.customWidget);
					}
				}
			}, this);

			this.dispatchEvent('formElementsCreated', this._widgets);
		},

		collectData: function() {
			fox.each(this._widgets, function(widget, alias) {
				if (widget.formElement) {
					var value = (fox.isEmpty(widget.getValue()) && !fox.isEmpty(this._defaults[alias])) ? this._defaults[alias] : widget.getValue();
					var value = widget.getValue();
					this._values[alias] = fox.clone(value, true);
				}
			}, this);
			this._preparedValues = {};
			this.hookWrapper('prepareValues', this);

			return this._preparedValues;
		},

		resetForm: function(fields) {
			fox.each(this._widgets, function(widget, alias) {
				if (widget.formElement && (!fields || (fox.isArray(fields) && fox.inArray(fields, alias)))) {
					var val = fox.isSet(this._beforeBuildValues[alias]) ? this._beforeBuildValues[alias] : this._defaults[alias];

					this._values[alias] = val;
					this.setValue(alias, val);
				}
			}, this);

			this._log = [];
			this._redoLog = [];
			this._beforeBuildValues = {};

			this.dispatchEvent('resetForm');
			return this;
		},

		setValue: function(alias, value) {
			if (!this._isBuilt) {
				this._beforeBuildValues[alias] = value;
				return this;
			}
			
			var w = this.getEmbeddedWidget(alias);

			if (w) {
				w.setValue(value);
				var params = {
					field: w.formElement,
					value: value,
					alias: alias
				};
				this.hookWrapper('valueChanged', params);
				this.dispatchEvent('valueChanged', params);
			} else {
				this._setValue(alias, value);
			}
		},

		setValues: function(values) {
			fox.each(values, function(value, alias) {
				this.setValue(alias, value);
			}, this);
		},

		valueChanged: function(params) {

		},

		getValue: function(alias) {
			var w = this.getEmbeddedWidget(alias);

			if (w) {
				return w.getValue();
			}

			return this._getValue(alias);
		},

		_getValue: function(alias) {
			return this._values[alias];
		},

		_logActions: function(alias, value) {
			if (this._values[alias] == value) {
				return;
			}

			if (this._skipLog) {
				this._skipLog = false;
				return;
			}

			if (!this._log.length) {
				this.dispatchEvent('undoListAvailable');
			}

			this._log.push({
				alias: alias,
				undo: fox.clone((this._values[alias] ? this._values[alias] : this._defaults[alias]), true),
				redo: fox.clone(value, true)
			});

			if (this._skipCleanRedo) {
				this._skipCleanRedo = false;
			} else {
				this._redoLog = [];
				this.dispatchEvent('redoListEmpty');
			}
		},

		_setValue: function(alias, value, noLog) {
			if (this._values[alias] == value) {
				return;
			}

			if (JSON.stringify(this._values[alias]) == JSON.stringify(value)) {
				return;
			}

			if (noLog !== true) {
				this._logActions(alias, value);
			}

			this._values[alias] = fox.clone(value, true);

			//this is centralized event for _all_ changes of form value.
			this.dispatchEvent('valueChange', {
				alias: alias,
				value: value
			});
			this.dispatchEvent('valueChanged_' + alias, value);


			if (this.autoSubmit || this.getOption('autoSubmit')) {
				this._submit();
			}

			return this;
		},

		undo: function() {
			var last = this._log.pop();

			if (last) {
				this._skipLog = true;
				this._skipCleanRedo = true;
				this.setValue(last.alias, last.undo);

				if (!this._redoLog.length) {
					this.dispatchEvent('redoListAvailable');
				}

				this._redoLog.push(last);
			}

			if (!this._log.length) {
				this.dispatchEvent('undoListEmpty');
			}

			return this;
		},

		undoAll: function() {
			fox.each(this._log, this.undo, this);
		},

		redo: function() {
			var last = this._redoLog.pop();

			if (last) {
				this._skipCleanRedo = true;
				this.setValue(last.alias, last.redo);
			} else {
				this.dispatchEvent('redoListEmpty');
			}

			return this;
		},

		_embedWidgetByElement: function (alias, elems, customWidget) {
			if (!elems || !elems.length) {
				return;
			}
			var tagName = elems[0].tagName.toLowerCase();
			var autoApply = this.options.autoApply || this.options.formElements[alias].autoApply || false;
			var wOptions = this.options.formElements[alias];
			
			if (!fox.isEmpty(customWidget)) {
				this.embedWidget(alias, customWidget.widget, fox.merge(customWidget, {
					elems: elems,
					autoApply: autoApply
				})).run();
				return this;
			}

			switch (tagName) {
				case 'input':
					var type = elems[0].type;

					switch (type) {
						case 'file':
							this.embedWidget(alias, 'Form_Element_File', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;
						
						case 'checkbox':
							this.embedWidget(alias, wOptions.widget || 'Form_Element_Checkbox', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;

						case 'radio':
							this.embedWidget(alias, 'Form_Element_Radio', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;

						case 'password':
						case 'text':
						case 'hidden':
						default:
							this.embedWidget(alias, 'Form_Element', fox.merge(wOptions, {
								elems: elems,
								autoApply: autoApply
							})).run();
						break;
					};

				break;

				case 'select':
					this.embedWidget(alias, 'Form_Element_Select', fox.merge(wOptions, {
						elems: elems,
						autoApply: autoApply
					})).run();
				break;

				case 'textarea':
					this.embedWidget(alias, 'Form_Element_Textarea', fox.merge(wOptions, {
						elems: elems,
						autoApply: autoApply
					})).run();
				break;
			}
			
			return this;
		},

		prepareValues: function (data) {
			this._preparedValues = this._values;
		},

		_submitHandler: function(el, alias, w, e) {
			e.preventDefault();
			e.stopPropagation();

			if (this._ignoreSubmit) {
				return false;
			}

			this._submit();
			return false;
		},

		_submit: function() {
			this.collectData();
			this.hookWrapper('submit', this._preparedValues);
		},

		submit: function(values) {
			if (!this.silent) {
				if (this.sendTimerId) {
					clearTimeout(this.sendTimerId);
				}

				this.sendTimerId = setTimeout(fox.bind(this._send, this), this.sendTimer);
			}

			this.dispatchEvent('submit', this._preparedValues);
		},

		_send: function() {
			if (this.getOption('sendTimezone') === true) {
				this._preparedValues.tz = fox.utils.getCurrentTimezone();
			}

			this.api.send(this._preparedValues, false);
		},

		response: function(answer, type, msg) {
			console.log('Form default responder: ', answer, type, msg);
		},

		disableAllElements: function() {
			fox.each(this._widgets, function(w, alias) {
				if (fox.oop.instanceOf(w, 'Form_Element')) {
					w.disable();
				}
			}, this);
			return this;
		},

		enableAllElements: function(alias) {
			fox.each(this._widgets, function(w, alias) {
				if (fox.oop.instanceOf(w, 'Form_Element')) {
					w.enable();
				}
			}, this);
			
			return this;
		},

		ignoreSubmit: function(flag) {
			this._ignoreSubmit = flag;
			return this;
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/form.js
// module id = 198
// module chunks = 0